export const deactivationsKeys = {
  reasons: ["deactivate", "reasons"],
};
